import React from "react";
import Header from "../../Header/Header";
import successImage from "../../../assets/images/HomeInspectorConfirmation.png";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../contexts/ProfileContext";

const VerifiedSuccessfully = () => {
    const navigate = useNavigate();
    const { fetchProfile } = useProfile();
    return (
        <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-bg-gray-100">
            <Header title={"Identity Verification"} />
            <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-gap-4 tw-shadow-lg tw-rounded-lg tw-p-6 tw-w-[90%] lg:tw-w-[70%] tw-text-center tw-border tw-border-gray-200">
                <div className="tw-max-w-[563px]">
                    {/* Success Icon */}
                    <div className="tw-flex tw-justify-center tw-mb-4">
                        <img className="tw-w-[200px] tw-h-[200px]" src={successImage} alt="" />
                    </div>

                    {/* Title */}
                    <h2 className="tw-text-[28px] tw-text-tertiary tw-font-semibold tw-mb-2">Successfully Submitted!</h2>

                    {/* Description */}
                    <p className="tw-text-tertiary tw-text-[20px]  tw-w-full tw-mb-4">
                        Congratulations! Your identity has been submitted. Our team will review your documents within 24-48 hours.{" "}
                    </p>

                    {/* Button */}
                    <button
                        onClick={() => {
                            fetchProfile();
                            navigate("/properties");
                        }}
                        className="tw-bg-primary tw-w-full hover:tw-bg-primary_hover tw-text-white tw-font-medium tw-px-6 tw-py-3 tw-rounded-md tw-transition"
                    >
                        Back To Home Screen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerifiedSuccessfully;
